import { SET_REPORT_DATA } from './actionTypes';

const setReportData = data => ({
    type: SET_REPORT_DATA,
    payload: data,
});

export default setReportData;
